/* istanbul ignore file */
import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { TutorialTooltip, ApplicationHeader } from '@adc/ui-adc'

const SearchHeaderWithNotifications = ({
  featureFlags,
  filters,
  user,
  onLocationSuggestionSelect,
}) => {
  const onSearchSubmit = suggestion => {
    if (suggestion.type === 'address') {
      window.location.assign(suggestion.link)
    } else {
      onLocationSuggestionSelect(suggestion)
    }
  }

  const getShowPurchaseProfileTooltip = () => {
    if (!featureFlags['fe.resi.enable_purchase_profile_nudge']) {
      return false
    }
    const noAssetType = filters.assetType.length === 0
    const REOAsset = _.includes(filters.assetType, 'bank-owned')
    return noAssetType || REOAsset
  }

  // this is needed to keep it comaptible with locationSuggestions hook
  const apiFiltersForHeaderSearch = _.omitBy(
    {
      property_city: filters.city[0],
      property_county: filters.county[0],
      property_state: filters.state[0],
      property_zip: filters.zip[0],
      search: filters.search,
      global_search: filters.globalSearch === 'y' ? 'y' : '',
    },
    _.isEmpty
  )

  const headerProps = {
    loadGoogleMaps: false,
    user: user.logged_in ? user : null,
    onSearchSubmit,
    redirectOnSelected: false,
    showLiveChat: true,
    featureFlags,
    showPurchaseProfileTooltip: getShowPurchaseProfileTooltip(),
    filters: apiFiltersForHeaderSearch,
  }

  return (
    <TutorialTooltip
      tutorial={1}
      position='bottom left'
      mobilePosition='bottom center'
      elmId='header_tutorial'
      header='Search Where You Want'
      content='Find your next investment in your area of interest.'
    >
      <ApplicationHeader headerProps={headerProps} />
    </TutorialTooltip>
  )
}

SearchHeaderWithNotifications.propTypes = {
  featureFlags: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  onLocationSuggestionSelect: PropTypes.func.isRequired,
}

export default SearchHeaderWithNotifications
